/** Wrong e-mail or password. Never says which one is wrong. */
export class IdentifiantsInvalidesError extends Error {
  override name = 'IdentifiantsInvalidesError';

  constructor() {
    super('Invalid credentials');
  }
}

/** The session is no longer accepted: the user has to sign in again. */
export class SessionExpireeError extends Error {
  override name = 'SessionExpireeError';

  constructor() {
    super('Session expired');
  }
}

export class TraductionIntrouvableError extends Error {
  override name = 'TraductionIntrouvableError';

  constructor(id: string) {
    super(`Translation not found: ${id}`);
  }
}

/** The service cannot be reached. */
export class ServiceIndisponibleError extends Error {
  override name = 'ServiceIndisponibleError';

  constructor(message = 'Service unavailable') {
    super(message);
  }
}

/**
 * The account has several work contexts and the configuration names none
 * (`VITE_ROSETTA_WORK_CONTEXT_ID`): Rosetta cannot guess which one to work in.
 */
export class ContexteTravailRequisError extends Error {
  override name = 'ContexteTravailRequisError';

  constructor(public readonly contextes: readonly { id: string | null; titre: string | null }[]) {
    super(
      `A work context is required: set VITE_ROSETTA_WORK_CONTEXT_ID. Available: ${JSON.stringify(contextes)}`,
    );
  }
}

/**
 * An interruption (#7) cancelled the translation but not everything it had started: some of its
 * sub-tasks refused (or could not be read). The task itself is cancelled, so the translation
 * reads as `interrompue`; the screen tells the user the interruption was not complete.
 */
export class InterruptionIncompleteError extends Error {
  override name = 'InterruptionIncompleteError';

  constructor(public readonly sousTachesRestantes: number) {
    super(`The interruption could not stop ${sousTachesRestantes} sub-task(s)`);
  }
}

/**
 * Some of the noyaux to add to a text (#11) are no longer free: translated, or being translated,
 * since the choice was shown (another tab, another device). Nothing was launched: Rosetta never
 * pays twice for the same noyau of the same text.
 */
export class NoyauxIndisponiblesError extends Error {
  override name = 'NoyauxIndisponiblesError';

  constructor(public readonly noyaux: readonly string[]) {
    super(`These noyaux are already translated or being translated: ${noyaux.join(', ')}`);
  }
}
